import template from "./auth.html";
import controller from "./auth.controller";
import "./auth.scss";

const AuthComponent = {
	template,
	controller,
	controllerAs: "auth"
};

export default AuthComponent;


// WEBPACK FOOTER //
// ./sources/components/auth/auth.component.js